import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createModalCounselingReservationDialogForm() {
  return new FormGroup({
    agree: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
  });
}
